import React from 'react'
import { IconArrowDown } from '../Icons'
import { Config } from '../../../config'
import styled from 'styled-components'

export const Select = ({
  options,
  id,
  value,
  onChange,
  placeholder,
}: SelectProps) => {
  return (
    <Container>
      <StyledSelect id={id} onChange={onChange} value={value}>
        <>
          {placeholder && (
            <option value="" disabled selected hidden>
              {placeholder}
            </option>
          )}
          {options.map((opt) => {
            return (
              <option
                value={opt.value}
                disabled={opt.disabled}
                key={`opt--${opt.value}__${opt.label}`}
              >
                {opt.label}
              </option>
            )
          })}
        </>
      </StyledSelect>
      <span>
        <IconArrowDown />
      </span>
    </Container>
  )
}

type SelectProps = {
  placeholder?: string
  value: any
  id?: string
  options: Option[]
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

type Option = {
  value: any
  disabled?: boolean
  label: string | number
}

const Container = styled.div`
  position: relative;
  width: 100%;
  margin-top: 0.6rem;
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    pointer-events: none;
    color: ${({ theme }) => theme.palette.primary};
    background: ${({ theme }) => theme.palette.secondary};
    right: 1px;
    top: 1px;
    pointer-events: none;

    height: calc(100% - 2px);
    width: 3.4rem;

    border-left: 1px solid rgba(34, 34, 34, 0.2);
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
  }

  & svg {
    width: 1.4rem;
  }
`

const StyledSelect = styled.select.attrs({
  className: 'py-0 px-3',
})`
  background: ${({ theme }) => theme.palette.secondary};
  border: 1px solid rgba(34, 34, 34, 0.2);
  height: 4.4rem;
  width: 100%;
  font-size: 1.3rem;
  border-radius: 0.4rem;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.palette.hint};

    & + span {
      border-color: ${({ theme }) => theme.palette.hint};
    }
  }

  &:focus {
    outline: 0;
    border-color: ${({ theme }) => theme.palette.primary};

    & + span {
      border-color: ${({ theme }) => theme.palette.primary};
    }
  }
`
